import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddVendor = createAsyncThunk(
  "other/AddVendor",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/vendor-create/`, data)
    return response.data
  }
); 

export const UpdateVendor = createAsyncThunk(
  "other/UpdateVendor",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/vendor-update/${data.id}/`, data)
    return response.data
  }
);

export const GetVendorList = createAsyncThunk(
  "user/GetVendorList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/vendor-list/`)
    return data
  }
);

export const GetVendorNameList = createAsyncThunk(
  "user/GetVendorNameList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/vendor-name-list/`)
    return data
  }
);

export const DeleteVendor = createAsyncThunk(
  "other/DeleteVendor",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/vendor-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

